import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "fs_18 fw_700" }
const _hoisted_5 = { class: "table table-striped" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Your compositions",
        text: "Your compositions",
        class: "mb-0"
      })
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.garments.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_localized_text, {
                  localizedKey: "No Elements Found",
                  text: "No Elements Found"
                })
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.garments, (garment) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-5",
              key: garment.identifier
            }, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(garment.text), 1),
              _createElementVNode("table", _hoisted_5, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Sub-type",
                        text: "Sub-type"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Composition",
                        text: "Composition"
                      })
                    ]),
                    _hoisted_6
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subTypesByGarment[garment.identifier], (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.subType
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.subType), 1),
                      _createElementVNode("td", null, [
                        (item.hasCustom)
                          ? (_openBlock(), _createBlock(_component_localized_text, {
                              key: 0,
                              localizedKey: "Custom",
                              text: "Custom"
                            }))
                          : (_openBlock(), _createBlock(_component_localized_text, {
                              key: 1,
                              localizedKey: "Edmond default",
                              text: "Edmond default"
                            }))
                      ]),
                      _createElementVNode("td", _hoisted_7, [
                        _createElementVNode("button", {
                          class: "btn btn-tertiary btn-sm me-2",
                          onClick: ($event: any) => (_ctx.edit(garment, item))
                        }, [
                          (!_ctx.isReadOnly)
                            ? (_openBlock(), _createBlock(_component_localized_text, {
                                key: 0,
                                localizedKey: "Edit",
                                text: "Edit"
                              }))
                            : (_openBlock(), _createBlock(_component_localized_text, {
                                key: 1,
                                localizedKey: "View",
                                text: "View"
                              }))
                        ], 8, _hoisted_8),
                        (item.hasCustom && !_ctx.isReadOnly)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-secondary btn-sm",
                              onClick: ($event: any) => (_ctx.confirmReset(garment, item))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Reset to Edmond",
                                text: "Reset to Edmond"
                              })
                            ], 8, _hoisted_9))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}